import ScrollView from './ScrollView';

export type { ScrollViewProps } from './ScrollView';
export default ScrollView;
